import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./layout/Layout";
import Dashboard from "./pages/Dashboard";
import Inventory from "./pages/Inventory";
import Order from "./pages/Order";
import Purchase from "./pages/Purchase";
import Billing from "./pages/Billing";
import Login from "./pages/Login";
import PrivateRoute from "./components/PrivateRoute";

const PERMISSIONS = {
  DASHBOARD: "order.view_dashboard",
  ORDER: "order.view_order",
  PURCHASE: "order.view_purchase",
  INVENTORY: "inventory.view_sheet",
  BILLING: "order.view_billing_page",
};

function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* Public Route */}
        <Route path="/login" element={<Login />} />

        {/* Protected Layout */}
        <Route
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        >

          {/* Default → Order Page */}
          <Route path="/" element={<Navigate to="/order" replace />} />

          {/* Orders */}
          <Route
            path="/order"
            element={
              <PrivateRoute requiredPermission={PERMISSIONS.ORDER}>
                <Order />
              </PrivateRoute>
            }
          />

          {/* Dashboard */}
          <Route
            path="/dashboard"
            element={
              <PrivateRoute requiredPermission={PERMISSIONS.DASHBOARD}>
                <Dashboard />
              </PrivateRoute>
            }
          />

          {/* Inventory */}
          <Route
            path="/inventory"
            element={
              <PrivateRoute requiredPermission={PERMISSIONS.INVENTORY}>
                <Inventory />
              </PrivateRoute>
            }
          />

          {/* Purchases */}
          <Route
            path="/purchase"
            element={
              <PrivateRoute requiredPermission={PERMISSIONS.PURCHASE}>
                <Purchase />
              </PrivateRoute>
            }
          />

          {/* Billing */}
          <Route
            path="/billing"
            element={
              <PrivateRoute requiredPermission={PERMISSIONS.BILLING}>
                <Billing />
              </PrivateRoute>
            }
          />

        </Route>

      </Routes>
    </BrowserRouter>
  );
}

export default App;